// Knowledge Items - Duas and Hadiths
export const knowledgeItems = [
	// ===== DUAS (Islamic Prayers) =====
	{
		id: "d1",
		category: "Dua",
		title: "Dua for Ease",
		content: "اللَّهُمَّ لاَ سَهْلَ إِلاَّ مَا جَعَلْتَهُ سَهْلاً وَأَنْتَ تَجْعَلُ الْحَزْنَ إِذَا شِئْتَ سَهْلاً",
		translation: "O Allah, there is no ease except what You make easy, and You make the difficulty easy if it be Your Will.",
		tag: "Hardship",
	},
	{
		id: "d2",
		category: "Dua",
		title: "Dua for Firmness",
		content: "يَا مُقَلِّبَ الْقُلُوبِ ثَبِّتْ قَلْبِي عَلَى دِينِكَ",
		translation: "O Changer of the hearts, make my heart firm upon Your religion.",
		tag: "Steadfastness",
	},
	{
		id: "d3",
		category: "Dua",
		title: "Dua for Strength",
		content: "رَبَّنَا لاَ تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا",
		translation: "Our Lord, let not our hearts deviate after You have guided us.",
		tag: "Guidance",
	},
	{
		id: "d4",
		category: "Dua",
		title: "Dua for Protection",
		content: "أَعُوذُ بِاللَّهِ مِنَ الشَّيْطَانِ الرَّجِيمِ",
		translation: "I seek refuge in Allah from Satan, the accursed.",
		tag: "Protection",
	},
	{
		id: "d5",
		category: "Dua",
		title: "Dua for Patience",
		content: "رَبَّنَا اصْبِرْنَا عَلَى طَاعَتِكَ وَارْزُقْنَا مِنْ حَيْثُ لاَ نَحْتَسِبُ",
		translation: "Our Lord, grant us patience in obeying You and provide for us from where we do not expect.",
		tag: "Patience",
	},
	{
		id: "d6",
		category: "Dua",
		title: "Dua for Forgiveness",
		content: "رَبِّ اغْفِرْ لِي خَطِيئَتِي وَجَهْلِي وَإِسْرَافِي",
		translation: "My Lord, forgive me my sin, my ignorance, and my transgression.",
		tag: "Forgiveness",
	},
	{
		id: "d7",
		category: "Dua",
		title: "Dua for Pure Heart",
		content: "يَا مُقَلِّبَ الْقُلُوبِ وَالأَبْصَارِ يَا مُدَبِّرَ اللَّيْلِ وَالنَّهَارِ",
		translation: "O Turner of hearts and sights, O Manager of night and day, turn our hearts to Your obedience.",
		tag: "Purification",
	},
	{
		id: "d8",
		category: "Dua",
		title: "Dua for Taqwa",
		content: "اللَّهُمَّ آتِ نَفْسِي تَقْوَاهَا وَزَكِّهَا أَنتَ خَيْرُ مَن زَكَّاهَا",
		translation: "O Allah, grant my soul its piety and purify it, for You are the best to purify it.",
		tag: "Piety",
	},
	{
		id: "d9",
		category: "Dua",
		title: "Dua for Resistance",
		content: "اللَّهُمَّ أَعِنِّي عَلَى ذِكْرِكَ وَشُكْرِكَ وَحُسْنِ عِبَادَتِكَ",
		translation: "O Allah, help me to remember You, to thank You, and to worship You well.",
		tag: "Support",
	},
	{
		id: "d10",
		category: "Dua",
		title: "Dua for Right Path",
		content: "اهْدِنَا الصِّرَاطَ الْمُسْتَقِيمَ صِرَاطَ الَّذِينَ أَنْعَمْتَ عَلَيْهِمْ",
		translation: "Guide us to the Straight Path, the path of those upon whom You have bestowed favor.",
		tag: "Guidance",
	},
	{
		id: "d11",
		category: "Dua",
		title: "Dua for Sincere Deeds",
		content: "رَبَّنَا اجْعَلْ عَمَلَنَا خَالِصًا لِوَجْهِكَ الْكَرِيمِ",
		translation: "Our Lord, make our deeds sincere for Your noble Face.",
		tag: "Sincerity",
	},
	{
		id: "d12",
		category: "Dua",
		title: "Dua for Breaking Bad Habits",
		content: "اللَّهُمَّ مَن أَرَادَنِي بِسُوءٍ فَأِرِدْهُ وَمَن أَرَادَ بِي خَيْرًا فَأِرِدْهُ",
		translation: "O Allah, whoever intends harm for me, turn their harm back to them, and whoever intends good for me, aid them.",
		tag: "Protection",
	},

	// ===== HADITHS (Sayings of the Prophet) =====
	{
		id: "h1",
		category: "Hadith",
		title: "Good Deeds Wipe Out Bad",
		content: "The Prophet (ﷺ) said: 'Have Taqwa of Allah wherever you are, and follow an evil deed with a good one to wipe it out...'",
		source: "Tirmidhi",
		tag: "Hope",
	},
	{
		id: "h2",
		category: "Hadith",
		title: "The Best of People",
		content: "The Prophet (ﷺ) said: 'The best of people are those who live the longest and do the most good deeds.'",
		source: "Tirmidhi",
		tag: "Excellence",
	},
	{
		id: "h3",
		category: "Hadith",
		title: "Sincere Repentance",
		content: "The Prophet (ﷺ) said: 'Whoever repents before the sun rises from the west, Allah will accept their repentance.'",
		source: "Muslim",
		tag: "Repentance",
	},
	{
		id: "h4",
		category: "Hadith",
		title: "Patience is Light",
		content: "The Prophet (ﷺ) said: 'Patience is light.' One of the greatest virtues in Islam.",
		source: "Muslim",
		tag: "Patience",
	},
	{
		id: "h5",
		category: "Hadith",
		title: "The Most Complete of Believers",
		content: "The Prophet (ﷺ) said: 'The most complete of the believers in faith are the best in character.'",
		source: "Tirmidhi",
		tag: "Character",
	},
	{
		id: "h6",
		category: "Hadith",
		title: "Actions Are By Intentions",
		content: "The Prophet (ﷺ) said: 'Actions are judged by their intentions, and each person shall have but that which they intended.'",
		source: "Bukhari & Muslim",
		tag: "Sincerity",
	},
	{
		id: "h7",
		category: "Hadith",
		title: "Small Acts Matter",
		content: "The Prophet (ﷺ) said: 'Do not belittle any good deed, even if it is just greeting your brother with a smile.'",
		source: "Muslim",
		tag: "Hope",
	},
	{
		id: "h8",
		category: "Hadith",
		title: "Mercy to Others",
		content: "The Prophet (ﷺ) said: 'The merciful will be shown mercy by Allah. Be merciful to those on earth and the One in the heavens will have mercy upon you.'",
		source: "Tirmidhi",
		tag: "Compassion",
	},
	{
		id: "h9",
		category: "Hadith",
		title: "Strength in Belief",
		content: "The Prophet (ﷺ) said: 'Whoever has firm faith in Allah and the Last Day, then let him either speak good or remain silent.'",
		source: "Bukhari & Muslim",
		tag: "Speech",
	},
	{
		id: "h10",
		category: "Hadith",
		title: "The Grateful Servant",
		content: "The Prophet (ﷺ) said: 'Whoever is not grateful for little, will not be grateful for much, and whoever is not grateful to people is not grateful to Allah.'",
		source: "Tirmidhi",
		tag: "Gratitude",
	},
	{
		id: "h11",
		category: "Hadith",
		title: "Distance From Sin",
		content: "The Prophet (ﷺ) said: 'The best thing a person can do is to keep away from what is forbidden and to abandon doubt about what is doubtful.'",
		source: "Tirmidhi",
		tag: "Purity",
	},
	{
		id: "h12",
		category: "Hadith",
		title: "Rights of Fellow Muslims",
		content: "The Prophet (ﷺ) said: 'No Muslim is a believer until he wishes for his brother what he wishes for himself.'",
		source: "Bukhari & Muslim",
		tag: "Brotherhood",
	},
	{
		id: "h13",
		category: "Hadith",
		title: "Fear of Allah",
		content: "The Prophet (ﷺ) said: 'The greatest wealth is the fear of Allah, and the greatest poverty is foolishness.'",
		source: "Tirmidhi",
		tag: "Taqwa",
	},
];
